<tabset type="tabs"
        class="ui-tab d-block pill">
    <tab heading="Display"
         class="row">
        <div class="modal-body">
            <div *ngIf="isGuideForm">
                <!--<div *ngIf="!guide.id" class="callout callout-info help-box">
                    <p>{{'help.2_guide_legend' | translate}}</p>
                </div>-->
                <div class="form-group">
                    <label class="field-required input-label">{{ 'application.title' | translate }}:</label>
                    <input class="form-control"
                           [(ngModel)]="guide.title"
                           type="text"
                           name="title"
                           #title="ngModel"
                           [rangeLength]="[2, 256]"
                           required
                           autofocus>
                    <p class="error"
                       *ngIf="title.errors?.required && title?.touched">{{ 'form.validate.required' | translate }}
                    </p>
                    <p class="error"
                       *ngIf="title.errors?.rangeLength">{{ 'form.validate.minLenght' | translate }} 2!</p>
                    <p class="error"
                       *ngIf="title.errors?.rangeLength">{{ 'form.validate.maxLenght' | translate }} 256!</p>
                </div>
                <div class="form-group">
                    <label class="field-required input-label">{{ 'Help text' | translate }}:</label>
                    <textarea class="form-control"
                              name="subtitle"
                              [(ngModel)]="guide.subtitle"
                              rows="1"
                              #subtitle="ngModel"
                              [rangeLength]="[2, 256]"></textarea>
                    <p class="error"
                       *ngIf="subtitle.errors?.rangeLength">{{ 'form.validate.minLenght' | translate }} 2!</p>
                    <p class="error"
                       *ngIf="subtitle.errors?.rangeLength">{{ 'form.validate.maxLenght' | translate }} 256!</p>
                </div>
            </div>

            <field-set-key [(fieldOptions)]="options"></field-set-key>
            <field-set-questiontype *ngIf="isGuideForm" [(fieldOptions)]="guide" [relatedDeterminants]="relatedDeterminants" [jsonDeterminants]="fieldOptions.jsonDeterminants" (dataChanged)="dataChangedEvent($event)"></field-set-questiontype>
            <field-set-short-label *ngIf="isEditGrid"
                                   [(fieldOptions)]="options"></field-set-short-label>
            <field-set-grid-ordernr *ngIf="isEditGrid"
                                    [(fieldOptions)]="options"></field-set-grid-ordernr>
            <field-set-description [(fieldOptions)]="options"
                                   *ngIf="options.tooltip !== undefined"></field-set-description>
            <field-set-tooltip [(fieldOptions)]="options"
                               *ngIf="options.description !== undefined"></field-set-tooltip>
            <field-set-style [(fieldOptions)]="options"
                             *ngIf="options.inputType == 'content' || options.inputType == 'mycontent'"></field-set-style>
            <field-set-notvisible [(fieldOptions)]="options"
                                  *ngIf="isComplexGrid"></field-set-notvisible>
            <field-set-notvisible-editmode [(fieldOptions)]="options"
                                  *ngIf="isComplexGrid"></field-set-notvisible-editmode>
            <field-set-total-visible-in-footer [(fieldOptions)]="options"
                                               *ngIf="isEditGrid && options.inputType=='number'"></field-set-total-visible-in-footer>
            <field-set-calculate-percentage [(fieldOptions)]="options" [(guides)]="guides"
                                            *ngIf="isEditGrid && options.inputType=='number'"></field-set-calculate-percentage>
            <field-set-calculate-shares-value [(fieldOptions)]="options" [(guides)]="guides"
                                              *ngIf="isEditGrid && options.inputType=='number'">
            </field-set-calculate-shares-value>
            <field-set-add-another-position [(fieldOptions)]="options"
                                              *ngIf="isEditGrid"></field-set-add-another-position>
            <field-set-table [(fieldOptions)]="options"
                             *ngIf="options.inputType == 'table'"></field-set-table>
            <field-set-content [(fieldOptions)]="options"
                               *ngIf="options.inputType == 'content'"></field-set-content>
            <field-set-mycontent [(fieldOptions)]="options"
                                 *ngIf="options.inputType == 'mycontent'"></field-set-mycontent>
            <field-set-date-format [(fieldOptions)]="options"
                                   *ngIf="options.format"></field-set-date-format>
            <field-set-time [(fieldOptions)]="options"
                            (dataChanged)="updateTimeFormat($event)"
                            *ngIf="options.enableTime !== undefined"></field-set-time>
            <field-set-date [(fieldOptions)]="options"
                            (dataChanged)="updateDateFormat($event)"
                            *ngIf="options.enableDate !== undefined"></field-set-date>
            <field-set-mask [(fieldOptions)]="options"
                            *ngIf="options.inputMask !== undefined"></field-set-mask>
            <field-set-disabled [(fieldOptions)]="options"></field-set-disabled>
            <field-set-hidden [(fieldOptions)]="options"></field-set-hidden>
            <div class="row">
                <div class="col-sm-12">
                    <primary-text-button [noLeftPadding]="true"
                                         (click)="saveForm()">{{ 'Save' |translate }}
                    </primary-text-button>
                </div>
            </div>
        </div>
    </tab>
    <tab heading="Data"
         class="row">
        <div class="modal-body">
            <field-set-select [(fieldOptions)]="options" [guideSelections]="guide.selections"
                              *ngIf="options.inputType == 'select'"></field-set-select>
            <field-set-radio [(fieldOptions)]="options"
                             [guideIsBoolean]="guide && guide.type === 'BOOLEAN' ? true : false"
                             *ngIf="options.inputType == 'radio'"></field-set-radio>
            <field-set-guide-classification [(fieldOptions)]="options"
                                      [(guides)]="guides"
                                      [guide]="guide"
                                      [(classificationsList)]="classificationsList"
                                            (dataChanged)="loadCatalogueFields($event)"
                                      *ngIf="options.inputType == 'classification' && isGuideForm"></field-set-guide-classification>
            <field-set-default [(fieldOptions)]="options"
                               [(classificationFields)]="classificationFields"
                               [guide]="guide"
                               [groupId]="guide.catalogGroupId"
                               *ngIf="options.defaultValue !== false"></field-set-default>
            <field-set-default-date [(fieldOptions)]="options"
                               *ngIf="options.inputType == 'datetime'"></field-set-default-date>
            <field-set-calculated-default [(fieldOptions)]="options"
                                          [allfields]="allfields"
                                          [fields]="fields"
                                          [notifications]="notifications"
                                          [guides]="guides"
                                          [tags]="tags"
                                          *ngIf="options.calculateValue !== undefined"></field-set-calculated-default>
            <field-set-calculated-max [(fieldOptions)]="options"
                                      [fields]="fields"
                                      [notifications]="notifications"
                                      [guides]="guides"
                                      [tags]="tags"
                                      *ngIf="isEditGrid && options.inputType=='number'"></field-set-calculated-max>
            <field-set-tag [(fieldOptions)]="options"
                           *ngIf="options !== undefined"></field-set-tag>
            <field-set-multiple [(fieldOptions)]="options"
                                *ngIf="options.multiple !== undefined && (options.inputType == 'select' || options.inputType == 'classification')"></field-set-multiple>
            <div class="row">
                <div class="col-sm-12">
                    <primary-text-button [noLeftPadding]="true"
                                         (click)="saveForm()">
                        {{ 'Save' | translate }}
                    </primary-text-button>
                </div>
            </div>
        </div>
    </tab>
    <tab heading="Validation"
         class="row">
        <div class="modal-body">
            <field-set-required [(fieldOptions)]="options"
                                *ngIf="options.validate && options.validate.required !== undefined"></field-set-required>
            <field-set-abbreviation [(fieldOptions)]="options" *ngIf="options.inputType == 'text' && options !== undefined"></field-set-abbreviation>
            <field-set-min [(fieldOptions)]="options"
                           *ngIf="options.validate && options.validate.min !== undefined"></field-set-min>
            <field-set-max [(fieldOptions)]="options"
                           *ngIf="options.validate && options.validate.max !== undefined"></field-set-max>
            <field-set-min-length [(fieldOptions)]="options"
                                  *ngIf="options.validate && options.validate.minLength !== undefined"></field-set-min-length>
            <field-set-max-length [(fieldOptions)]="options"
                                  *ngIf="options.validate && options.validate.maxLength !== undefined"></field-set-max-length>
            <field-set-required-total-percentage [(fieldOptions)]="options"
                                                 *ngIf="isEditGrid && options.inputType=='number' && options.validate"></field-set-required-total-percentage>
            <field-set-required-rows [(fieldOptions)]="options"
                                *ngIf="options.inputType=='editgrid' && options.validate"
                                     [guides]="guides"></field-set-required-rows>
            <field-set-min-rows [(fieldOptions)]="options"
                                *ngIf="options.inputType=='editgrid' && options.validate"></field-set-min-rows>
            <field-set-required-one-true [(fieldOptions)]="options"
                                         *ngIf="isEditGrid && options.inputType=='checkbox' && options.validate"></field-set-required-one-true>
            <field-set-date-later-than-now [(fieldOptions)]="options"
                                           *ngIf="options.validate && options.validate.laterThanNow !== undefined"></field-set-date-later-than-now>
            <field-set-older-than-age [(fieldOptions)]="options"
                                      *ngIf="options.validate && options.validate.olderThan !== undefined"></field-set-older-than-age>
            <field-set-later-than [(fieldOptions)]="options"
                                  *ngIf="options.validate && options.validate.laterThan !== undefined"></field-set-later-than>
            <field-set-earlier-than [(fieldOptions)]="options"
                                    *ngIf="options.validate && options.validate.earlierThan !== undefined"></field-set-earlier-than>
            <div class="row">
                <div class="col-sm-12">
                    <primary-text-button [noLeftPadding]="true"
                                         (click)="saveForm()">
                        {{ 'Save' | translate }}
                    </primary-text-button>
                </div>
            </div>
        </div>
    </tab>
    <tab class="pt-2 pb-2">
        <ng-template tabHeading>
          <span tooltip="{{determinantTooltip | translate}}">Determinants ({{countNumberOfDeterminants()}})</span>
        </ng-template>
        <determinant-new *ngIf="store.state.common.determinantSection.topLayer === 'edit' && context === 'options'"
                          class="row layer sub-layer px-3 pt-1"
                          style="width: auto;margin: 0 -15px;"
                          [serviceId]="serviceId"
                          [determinant]="store.state.common.determinantSection.determinant"
                          (formSubmit)="closeDetLayer()"
                          (editCancel)="closeDetLayer()"></determinant-new>
        <determinant-builder-new class="{{store.state.common.determinantSection.topLayer === 'edit' ? 'hidden' : ''}} tabbed-list"
                                 [serviceId]="serviceId"
                                 [jsonString]="fieldOptions.jsonDeterminants"
                                 (onSave)="saveForm()"
                                 (onChange)="updateGroup($event)">
        </determinant-builder-new>
    </tab>
</tabset>
